module.exports = __webpack_public_path__ + "static/icon-fbb89aedad44afc9e9beb3628df27e28.svg";